import { render, staticRenderFns } from "./PanelCompetitionSettingLayout.vue?vue&type=template&id=4d071cf5&scoped=true&"
import script from "./PanelCompetitionSettingLayout.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingLayout.vue?vue&type=script&lang=js&"
import style0 from "@melloware/coloris/dist/coloris.css?vue&type=style&index=0&lang=css&"
import style1 from "./PanelCompetitionSettingLayout.vue?vue&type=style&index=1&id=4d071cf5&lang=css&"
import style2 from "./PanelCompetitionSettingLayout.vue?vue&type=style&index=2&id=4d071cf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d071cf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d071cf5')) {
      api.createRecord('4d071cf5', component.options)
    } else {
      api.reload('4d071cf5', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingLayout.vue?vue&type=template&id=4d071cf5&scoped=true&", function () {
      api.rerender('4d071cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingLayout.vue"
export default component.exports